import { StyleSheet } from 'react-native'
import { fontFamily, color } from '../../../../../theme'

export const styles = StyleSheet.create({
  container: {
    backgroundColor: color.palette.cream,
    alignItems: 'center',
    padding: 60,
    paddingHorizontal: 100,
    gap: 30
  },
  chipContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 5
  },
  chipText: {
    fontWeight: '500',
    fontFamily: fontFamily.GTAmericaExtendedMedium,
    fontSize: 18,
    color: 'black',
    lineHeight: 21.6,
    letterSpacing: -0.5,
    textAlign: 'center'
  },
  winnerContainer: {
    maxWidth: 120
  },
  winnerText: {
    textAlign: 'center',
    fontFamily: fontFamily.FeatureDeckRegular,
    fontSize: 28,
    lineHeight: 33.6,
    fontWeight: '400'
  }
})
